import axiosInstance from '../axiosInstance';
 
// Fetch candidate dashboard details
export const getCandidateDashboard = async () => {
  try {
    const response = await axiosInstance.get('/candidate/dashboard-details');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching candidate dashboard:', error);
    throw error;
  }
};

// Fetch candidate signature
export const getCandidateSignature = async () => {
  try {
    const response = await axiosInstance.get('/candidate/signatures/get/signature');
    return response.data;
  } catch (error) {
    console.error('Error fetching candidate signature:', error);
    throw error;
  }
};
 
// Save candidate signature
export const saveCandidateSignature = async (signatureFile, method) => {
  try {
    const formData = new FormData();
    formData.append('signatureFile', signatureFile);
    formData.append('method', method);
 
    const response = await axiosInstance.post('/candidate/signatures', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
 
    return response.data;
  } catch (error) {
    console.error('Error saving candidate signature:', error);
    throw error;
  }
};
 
// Create personal info
export const createPersonalInfo = async (personalInfoData) => {
  try {
    const response = await axiosInstance.post('/candidate/add/personal-info', personalInfoData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating candidate personal info:', error);
    throw error;
  }
};
 
// Fetch personal info
export const getPersonalInfo = async (candidateId = null) => {
  try {
    const url = candidateId
      ? `/candidate/personal-info/${candidateId}`
      : '/candidate/personal-info';
    const response = await axiosInstance.get(url);
    return response;
  } catch (error) {
    console.error('Error fetching candidate personal info:', error);
    throw error;
  }
};
 
// Save address info
export const saveAddressInfo = async (formData) => {
  try {
    const response = await axiosInstance.post('/candidate/add/address-info', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error saving address info:', error);
    throw error.response || error;
  }
};
 
// Fetch address info (Updated to include candidateId)
export const getAddressInfo = async () => {
  try {
    const response = await axiosInstance.get('/candidate/get/address-info');
    return response;
  } catch (error) {
    console.error('Error fetching address info:', {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw error;
  }
};
 
 
// Fetch candidate profile
export const getCandidateProfile = async () => {
  try {
    const response = await axiosInstance.get('/candidate/profile');
    return response.data;
  } catch (error) {
    console.error('Error fetching candidate profile:', error);
    throw error;
  }
};
 
// Update candidate profile
export const updateCandidateProfile = async (profileData) => {
  try {
    const response = await axiosInstance.put('/candidate/profile', profileData);
    return response.data;
  } catch (error) {
    console.error('Error updating candidate profile:', error);
    throw error;
  }
};
 
// Fetch high school data
export const getHighSchoolData = async () => {
  try {
    const response = await axiosInstance.get('/candidate/education/get/high-school');
    return response.data.data; 
  } catch (error) {
    console.error('Error fetching high school data:', error);
    throw error;
  }
};
 
// Save high school data
export const saveHighSchoolData = async (formData) => {
  try {
    const response = await axiosInstance.post('/candidate/education/add/high-school', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error saving high school data:', error);
    throw error.response || error;
  }
};
 
// Fetch higher secondary data
export const getHigherSecondaryData = async () => {
  try {
    const response = await axiosInstance.get('/candidate/education/get/higher-secondary');
    return response.data.data; // Extract CandidateEducationResponse from ApiResponse
  } catch (error) {
    console.error('Error fetching higher secondary data:', error);
    throw error;
  }
};
 
export const saveHigherSecondaryData = async (formData) => {
  try {
    const response = await axiosInstance.post('/candidate/education/add/higher-secondary', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error saving higher secondary data:', error);
   throw error.response?.data || error;
  }
};
 
export const getDiplomaData = async () => {
  try {
    const response = await axiosInstance.get('/candidate/education/get/diploma');
    return response.data.data; // Extract CandidateEducationResponse
  } catch (error) {
    console.error('Error fetching diploma data:', error);
    throw error;
  }
};
 
// Save diploma details
export const saveDiplomaDetails = async (formData) => {
  try {
    const response = await axiosInstance.post('/candidate/education/add/diploma', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error saving diploma details:', error);
    throw error.response?.data || error;
  }
};
 
export const getUndergraduateData = async () => {
  try {
    const response = await axiosInstance.get('/candidate/education/get/undergraduate');
    return response.data.data; // Extract CandidateEducationResponse
  } catch (error) {
    console.error('Error fetching undergraduate data:', error);
    throw error;
  }
};
 
// Save undergraduate details
export const saveUndergraduateDetails = async (formData) => {
  try {
    const response = await axiosInstance.post('/candidate/education/add/undergraduate', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error saving undergraduate details:', error);
    throw error.response?.data || error;
  }
};
 
 
export const getPostgraduateData = async () => {
  try {
    const response = await axiosInstance.get('/candidate/education/get/postgraduate');
    return response.data.data; // Extract CandidateEducationResponse
  } catch (error) {
    console.error('Error fetching postgraduate data:', error);
    throw error;
  }
};
 
// Save postgraduate details
export const savePostgraduateDetails = async (formData) => {
  try {
    const response = await axiosInstance.post('/candidate/education/add/postgraduate', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error saving postgraduate details:', error);
    throw error.response?.data || error;
  }
};
 
export const deleteEducation = async (level) => {
  try {
    if (!level) {
      throw new Error('Invalid education level for deletion');
    }
    const response = await axiosInstance.delete(`/candidate/education/delete/${level}`); 
    return response.data;
  } catch (err) {
    console.error('Delete education error:', {
      message: err.message,
      status: err.response?.status,
      data: err.response?.data,
    }); 
    throw err;
  }
};
 
// Fetch all employment records
export const getAllEmploymentData = async () => {
  try {
    const response = await axiosInstance.get('/candidate/employment-info/all');
    return response.data.data; // Extract List<CandidateEmploymentInfoResponse>
  } catch (error) {
    console.error('Error fetching all employment data:', error);
    throw error;
  }
};
 
// Fetch employment record by ID
export const getEmploymentById = async (employmentId) => {
  try {
    const response = await axiosInstance.get(`/candidate/employment-info/${employmentId}`);
    return response.data.data; // Extract CandidateEmploymentInfoResponse
  } catch (error) {
    console.error(`Error fetching employment data for ID ${employmentId}:`, error);
    throw error;
  }
};
 
// Save employment details
export const saveEmploymentDetails = async (formData) => {
  try {
    const response = await axiosInstance.post('/candidate/employment-info', formData, {
  
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
        
    return response.data;
  } catch (error) {
    console.error('Error saving employment details:', error);

    throw error.response?.data || error;
  }
};
 
 
export const updateEmployment = async (employmentId, formData) => {
  try {
    const response = await axiosInstance.put(`/candidate/employment-info/${employmentId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating employment details:', error);
    throw error.response?.data || error;
  }
};
export const deleteEmployment = async (id) => {
  try {
    if (!id) {
      throw new Error('Invalid employment ID');
    }
    const response = await axiosInstance.delete(`/candidate/employment-info/${id}`); 
    return response.data;
  } catch (err) {
    console.error('Delete employment error:', {
      message: err.message,
      status: err.response?.status,
      data: err.response?.data,
    }); 
    throw err;
  }
};

export const checkSubmissionStatus = async () => {
  try {
    const response = await axiosInstance.get('/candidate/check-submission');
    return response.data;
  } catch (error) {
    console.error('Error checking submission status:', error);
    throw error;
  }
};

// Fetch candidate data status (personal + address completion check)
export const getCandidateDataStatus = async () => {
  try {
    const response = await axiosInstance.get('/candidate/personal/address');
    return response.data;
    // Expected format:
    // {
    //   status: true,
    //   statusCode: 200,
    //   message: "Candidate data status fetched successfully",
    //   data: {
    //     candidateId: "TRU000079",
    //     addressInfoPresent: true,
    //     personalInfoPresent: true,
    //     dataComplete: true
    //   }
    // }
  } catch (error) {
    console.error('Error fetching candidate data status:', error);
    throw error;
  }
};

export const sendEditCandidateRequest = async (selectedRequests) => {
  try {
    const response = await axiosInstance.post(  "/candidate/edit-candidate",  { selectedRequests }  );
    return response.data;
  } catch (error) {
    console.error("Error sending edit candidate request:", error);
    throw error.response?.data || { message: "Request failed" };
  }
};

export const askCandidateChatbot = async (question) => {
  try {
    const response = await axiosInstance.post('/candidate/chatbot/ask', { question });
    return response.data;
  } catch (error) {
    console.error('Error asking chatbot:', error);
    throw error;
  }
};

export const fetchBasicCandidateInfo = () => {
  return axiosInstance.get(`/candidate/getBasicInfo`);
};

export const fetchCandidateNextStep = () => {
  return axiosInstance.get(`/candidate/getNextStep`);
};
